import React from "react";

const FilterComponent = ({filterText, onFilter, onClear}) => (
    <div className="row">
        <div className="col-6 float-end">
            <input className="form-control"
                   id="search"
                   type="text"

                   placeholder="Suchtext"
                   value={filterText}
                   onChange={onFilter}
            />
        </div>
        <div className="col-3 float-end">
            <button type="button" className="btn" onClick={onClear}>
                X
            </button>
        </div>
    </div>
);

export default FilterComponent;